import React from 'react';

const Privacy = () =>{
    return(
        <React.Fragment>Privacy Page</React.Fragment>
    )
}

export default Privacy;